import { fetchLearnerPathLocallyOrRemotely } from './LearningSpaceServices/fetchLearnerPath';
import User from './currentUser';

const user = new User();
const userId = user.id();

const contentLockStatus = async (contentId, parentIds) => {
  const allContents = await Promise.all(
    parentIds.map(parentId => fetchLearnerPathLocallyOrRemotely(parentId, userId))
  );

  const orderedContents = allContents.filter(
    item =>
      item.pathOffer.unlockOrderType === 'specificOrder' ||
      item.pathOffer.unlockOrderType === 'inOrder'
  );

  if (!orderedContents.length) {
    return false;
  }

  const unlockedContents = orderedContents.filter(curriculum => {
    const curriculumOffer = curriculum.pathOffer;
    const contentOffer = curriculumOffer.offers.find(content => content.offerId === contentId);
    const allStates = curriculum.states;
    if (!contentOffer) {
      return true;
    }
    if (curriculumOffer.unlockOrderType === 'inOrder') {
      const inOrderContents = curriculumOffer.offers
        .filter(offer => offer && offer.position < contentOffer.position)
        .map(item => item.offerId);
      const inOrderStates = inOrderContents.map(cid =>
        allStates.find(content => content.contentId === cid)
      );
      if (
        inOrderStates.filter(
          contentItem => contentItem && contentItem.completionStatus !== 'complete'
        ).length
      ) {
        return false;
      }
    } else if (curriculum.unlockOrderType === 'specificOrder') {
      const specificOrderContents = curriculumOffer.offers
        .filter(offer => offer && offer.order < contentOffer.order)
        .map(item => item.offerId);
      const specificOrderStates = specificOrderContents.map(cid =>
        allStates.find(content => content.contentId === cid)
      );
      if (
        specificOrderStates.filter(
          contentItem => contentItem && contentItem.completionStatus !== 'complete'
        ).length
      ) {
        return false;
      }
    }
    return true;
  });

  if (unlockedContents.length !== orderedContents.length) {
    return true;
  }

  return false;
};

export { contentLockStatus };
export default contentLockStatus;
